import { createSlice } from "@reduxjs/toolkit";

export const SuppressionList = createSlice({
  name: "SuppressionList",
  initialState: {
    value: false, // default state
    code: false,
  },
  reducers: {
    // reducers action
    setSuppressionList: (state, { payload, code }) => {
      state.value = payload;
      state.code = code;
    },
  },
});

export const { setSuppressionList } = SuppressionList.actions;
export default SuppressionList.reducer;
